import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

interface Props {
  label?: string
  time: string
}

const ReservationTime = ({ label, time }: Props) => {
  return (
    <div className="flex items-center gap-1">
      {label && (
        <Typography variant="label-semibold" color={tailwindColors.grey.DEFAULT}>
          {label}
        </Typography>
      )}
      <Badge text={time} variant="white" size="xsmall" color={tailwindColors.grey.light.DEFAULT} />
    </div>
  )
}

export default ReservationTime
